import React from 'react';
import { Insight } from 'libs/end-to-end/src/insights';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { getCalibrationScore } from 'libs/end-to-end/src/tests-utils';
import { getCalibrationLevel } from 'libs/end-to-end/src/calibration-level';

export const InsightImage: React.FC<{
  insight: Insight;
  calibrationFraming: CalibrationFraming;
}> = ({ insight }) => {
  let imgSrc = '';
  let imgAlt = '';

  if (insight.type === 'parity') {
    imgSrc = '/images/dimensions/Image-Parity.png';
    imgAlt = 'Parity';
  } else if (insight.type === 'disparity') {
    imgSrc = '/images/dimensions/Image-Disparity.png';
    imgAlt = 'Disparity';
  } else if (insight.type === 'optimization') {
    const counts = insight.totalTestCount ?? {
      total: 0,
      passing: 0,
      failing: 0,
      incomplete: 0,
    };

    const score = getCalibrationScore({
      testCount: counts,
    });
    const level = getCalibrationLevel(score);

    if (level === 'poor' || level === 'belowAverage') {
      imgSrc = '/images/dimensions/Image-Optimization-Low.png';
      imgAlt = 'Low Optimization';
    } else if (level === 'average') {
      imgSrc = '/images/dimensions/Image-Optimization-Medium.png';
      imgAlt = 'Medium Optimization';
    } else {
      imgSrc = '/images/dimensions/Image-Optimization-High.png';
      imgAlt = 'High Optimization';
    }
  }

  if (!imgSrc || !imgAlt) {
    return <></>;
  }

  return <img src={imgSrc} alt={imgAlt} className="w-full" />;
};
